
  // faq accordian
  $(document).ready(function() {
    //toggle the component with class accordion__body
    $(".accordion__head").click(function() {
      if ($('.accordion__body').is(':visible')) {
        $(".accordion__body").slideUp(300);
        $(".plusminus").text('+');
      }
      if ($(this).next(".accordion__body").is(':visible')) {
        $(this).next(".accordion__body").slideUp(300);
        $(this).children(".plusminus").text('+');
      } else {
        $(this).next(".accordion__body").slideDown(300);
        $(this).children(".plusminus").text('-');
      }
    });
    });


// cross sell / add to cart

  // targeting the styled visible div 
  var addtocartBttn1 = document.querySelector('.add-to-cart-bttn-uno');
  var addtocartBttn2 = document.querySelector('.add-to-cart-bttn-dos');
  // to trigger the hidden input/buttons
  var upselltocartUno = document.getElementById('upsell-to-cart-uno');
  var upselltocartDos = document.getElementById('upsell-to-cart-dos');

  upselltocartUno.addEventListener("click", upselltocartbttn1);
  upselltocartDos.addEventListener("click", upselltocartbttn2);

  function upselltocartbttn1 () {
    var addtocartBttn1 = document.querySelector('.add-to-cart-bttn-uno').click();
    upselltocartUno.style.backgroundColor = '#0FB1A6';
    upselltocartUno.style.color = 'white';
    upselltocartUno.border = '2px solid transparent';
  }
  function upselltocartbttn2 () {
    var addtocartBttn2 = document.querySelector('.add-to-cart-bttn-dos').click();
    upselltocartDos.style.backgroundColor = '#0FB1A6';
    upselltocartDos.style.color = 'white';
    upselltocartDos.border = '2px solid transparent';
  }


  // these are for the Add to Cart conversion tracking tag - Google Ads.
  // one tracks the Add to Cart Button, and one tracks the Floating Add to Cart 

  window.addEventListener('load', function() {
    jQuery('#AddToCart').click(function() {
      gtag('event', 'conversion', {'send_to': 'AW-659860719/AV0OCLSemIEDEO_Z0roC'}); // for google ads
      console.log('clicked');
    });
  });
  window.addEventListener('load', function() {
    jQuery('#StickyAddToCart').click(function() {
      gtag('event', 'conversion', {'send_to': 'AW-659860719/AV0OCLSemIEDEO_Z0roC'}); // for google ads
          console.log('clicked');
    });
  });

